const { PHONE_REGEX } = require("Utils/regex/phone");
const { preloadDictionaries } = require("Utils/translate");
const { BLOCKED_EMAIL_DOMAINS } = require("@/constants/registration");
import "./style.less";

const ViewModel = function (defaultData) {
  this.initializing = ko.observable(true);

  this.isSubmitted = ko.observable(false);

  this.rememberMe = ko.observable(true);

  const domain = "/foquz/api";
  const defaultCodeTimeout = 30;

  this.codeError = ko.observable(false);
  this.codeEnded = ko.observable(false);
  this.isAjaxSended = ko.observable(false);
  this.registration_id = ko.observable(false);
  this.url = ko.observable(false);
  this.decoratedTimeout = ko.observable("");

  this.activeRegistrationStep = ko.observable(0);

  this.interval = false;
  this.timeout = ko.observable("");

  this.pending = ko.observable(false);
  this.loginPending = ko.observable(false);

  const that = this;

  this.registrationSteps = (() => {
    const passwordIsValid = ko.observable(false);
    return { passwordIsValid };
  })();

  that.serverErrors = {
    phone: ko.observable(''),
    email: ko.observable(''),
  };

  that.hasServerErrors = ko.computed(() => {
    return !!that.serverErrors.phone() || !!that.serverErrors.email();
  })

  this.loginFormModel = ko.validatedObservable(
    {
      name: ko.observable(defaultData.username || "").extend({
        required: {
          message: _t("main", "Обязательное поле"),
        },
        minLength: {
          params: 2,
          message: _t("main", "Должно быть введено хотя бы {characters}", {
            characters: _t("main", "{count} символа", { count: 2 }),
          }),
        },
      }),
      password: ko.observable(defaultData.password || "").extend({
        required: {
          message: _t("main", "Обязательное поле"),
        },
        minLength: {
          params: 6,
          message: _t("main", "Должно быть введено хотя бы {characters}", {
            characters: _t("main", "{count} символов", { count: 6 }),
          }),
        },
      }),
    },
    { deep: true, live: true }
  );

  this.registrationFormModelStep1 = ko.validatedObservable(
    {
      password: ko.observable('').extend({
        required: {
          message: _t("main", "Обязательное поле"),
        },
        validation: {
          validator: () => {
            return that.registrationSteps.passwordIsValid();
          },
        },
      }),
      retypePassword: ko.observable("").extend({
        required: {
          message: _t("main", "Обязательное поле"),
        },
        validation: {
          validator: function (value) {
            return (
              that.registrationFormModelStep1() === null ||
              value === that.registrationFormModelStep1().password()
            );
          },
          message: _t(
            "main",
            "Значение должно совпадать со значением параметра «{param}»",
            {
              param: _t("main", "Пароль"),
            }
          ),
        },
      }),
      email: ko.observable("").extend({
        required: {
          message: _t("main", "Обязательное поле"),
        },
        minLength: {
          params: 2,
          message: _t("main", "Должно быть введено хотя бы {characters}", {
            characters: _t("main", "{count} символа", { count: 2 }),
          }),
        },
        email: {
          message: _t("main", "Неверный формат параметра «{param}»", {
            param: "Email",
          }),
        },
        validation: {
          validator: function (value) {
            const v = String(value || "").trim().toLowerCase();
            const domain = v.includes("@") ? v.split("@").pop() : "";
            return domain && !BLOCKED_EMAIL_DOMAINS.includes(domain);
          },
          message: 'Пожалуйста, используйте почтовый сервис в доменной зоне .ru.\nМы настоятельно рекомендуем указывать корпоративный email-адрес даже при пробной регистрации.',
        },
      }),
      isConfirm: ko.observable(false).extend({
        validation: {
          validator: (v) => {
            return v;
          },
          message: _t(
            "user",
            "Принятие условий пользовательского соглашения и согласие на обработку персональных данных обязательно для продолжения регистрации"
          ),
        },
      }),
			isProcessingPolicy: ko.observable(false).extend({
        validation: {
          validator: (v) => {
            return v;
          },
          message: _t(
            "user",
            "Принятие политики обработки персональных данных обязательно для продолжения регистрации"
          ),
        },
      }),
    },
    { deep: true, live: true }
  );

  this.registrationFormModelStep1().email.subscribe(() => {
    that.serverErrors.email('');
  });

  this.registrationFormModelStep2 = ko.validatedObservable(
    {
      phone: ko.observable("").extend({
        required: {
          message: _t("main", "Обязательное поле"),
        },
        pattern: {
          params: PHONE_REGEX,
          message: _t("main", "Некорректный формат"),
        },
      }),
      name: ko.observable(""),
    },
    { deep: true, live: true }
  )


  this.registrationFormModelStep2().phone.subscribe(() => {
    that.serverErrors.phone('');
  });

  this.formControlErrorStateMatcher = function (formControl) {
    return ko.computed(function () {
      return that.isSubmitted() && !formControl.isValid();
    });
  };

  this.formControlSuccessStateMatcher = function (formControl) {
    return ko.computed(function () {
      return that.isSubmitted() && formControl.isValid();
    });
  };

  this.submit = function () {
    this.isSubmitted(true);
    if (!this.loginFormModel.isValid()) return;
    $("#login-form").submit();
    this.isSubmitted(false);
  };

  this.submitLogin = async function () {
    this.isSubmitted(true);
    if (!this.loginFormModel.isValid()) return;

    this.loginPending(true);

    const smartToken = await getToken(window.loginSmartCaptchaWidgetId);
    if (!smartToken && window.smartCaptcha) {
      this.loginPending(false);
      return;
    }

    const tokenInput = document.querySelector('#login-captcha-container input[name="smart-token"]');
    if (tokenInput) {
      tokenInput.value = smartToken || '';
    }
    $("#login-form").submit();
  };

  this.submitStep = function () {
    this.isSubmitted(true);
    const step = that.activeRegistrationStep();
    switch (step) {
      case 0:
        if (!this.registrationFormModelStep1.isValid()) return;
        this.pending(true);
        this.postStep1()
        break;
      case 1:
        if (!this.registrationFormModelStep2.isValid()) return;
        this.pending(true);
        this.postStep2()
        break;
      default:
        break;
    }
  }

  const getToken = async (widgetId) => {
    if (!window.smartCaptcha) return;
    return new Promise((resolve) => {
      let unsubscribe;
      const callback = (v) => {
        const token = typeof v === 'string' ? v : null;
        window.smartCaptcha.reset(widgetId);
        Array.isArray(unsubscribe) && unsubscribe.forEach(u => u());
        resolve(token);
      }
      unsubscribe = [
        window.smartCaptcha.subscribe(
          widgetId,
          'challenge-hidden',
          callback,
        ),
        window.smartCaptcha.subscribe(
          widgetId,
          'network-error',
          callback,
        ),
        window.smartCaptcha.subscribe(
          widgetId,
          'javascript-error',
          callback,
        ),
        window.smartCaptcha.subscribe(
          widgetId,
          'success',
          callback,
        ),
      ];
      window.smartCaptcha.execute(widgetId);
    })
  }

  that.userId = '';
  that.loginUrl = '';
  that.accessToken = '';
  that.companyAlias = '';
  that.smartToken = '';
  
  this.postStep1 = async () => {
    Object.values(that.serverErrors).forEach(e => e(''));
    that.pending(true);

    that.smartToken = await getToken(window.smartCaptchaWidgetId);
    if (!that.smartToken && window.smartCaptcha) {
      that.pending(false);
      return;
    }

    const {
      email,
      password,
      retypePassword,
    } = this.registrationFormModelStep1();
    $.post(domain + "/company-register/first-step", {
      email: email(),
      password: password(),
      repeatPassword: retypePassword(),
      'smart-token': that.smartToken,
    })
      .done(function (data) {
        const {
          access_token: accessToken,
          company_alias: companyAlias,
          loginUrl,
          user_id: userId,
        } = data;
        that.userId = userId;
        that.loginUrl = loginUrl;
        that.accessToken = accessToken;
        that.companyAlias = companyAlias;
        that.pending(false);
        that.isSubmitted(false);
        that.activeRegistrationStep(1);
      })
      .fail(function (e) {
        const {
          responseJSON: {
            errors,
          } = {}
        } = e;
        if (errors.email) {
          that.serverErrors.email(errors.email);
        }
        that.pending(false);
        that.isSubmitted(false);
      });
  };

  this.postStep2 = async () => {
    Object.values(that.serverErrors).forEach(e => e(''));
    that.pending(true);

    that.smartToken = await getToken(window.smartCaptchaWidgetId);
    if (!that.smartToken && window.smartCaptcha) {
      that.pending(false);
      return;
    }

    const {
      phone,
      name,
    } = this.registrationFormModelStep2();
    const {
      email,
      password,
      retypePassword,
    } = this.registrationFormModelStep1();
    $.post(domain + "/company-register/second-step", {
      phone: phone(),
      name: name(),
      email: email(),
      password: password(),
      repeatPassword: retypePassword(),
      user_id: that.userId,
      access_token: that.accessToken,
      'smart-token': that.smartToken,
    })
      .done(function (data) {
        that.login();
      })
      .fail(function ({ responseJSON: { errors } = {} } = {}) {
        if (errors.phone) {
          that.serverErrors.phone(errors.phone);
        }
        that.pending(false);
        that.isSubmitted(false);
      });
  };

  this.login = function () {
    const csrf = document.getElementById('csrf');
    const {
      email,
      password,
    } = this.registrationFormModelStep1();
    $.ajax({
      url: "/user-management/auth/login",
      method: 'POST',
      data: {
        [csrf.name]: csrf.value,
        username: email(),
        password: password(),
      },
      statusCode: {
        302: () => {
          document.location.reload();
        },
      }
    });
  }

  window._testCreateCompanyStep = () => {
    this.registrationFormModel().email("user@user.com");
    this.registrationFormModel().code("1234");
    this.activeRegistrationStep(2);
  };

  this.timeout.subscribe(function () {
    let mins = (that.timeout() / 60000) | 0,
      secs = ((that.timeout() - mins * 60000) / 1000) | 0;
    if (String(mins).length < 2) {
      mins = "0" + mins;
    }
    if (String(secs).length < 2) {
      secs = "0" + secs;
    }
    that.decoratedTimeout(mins + ":" + secs);
  });

  this.onInit = () => {
    this.initializing(false);
  };
};

$(document).ready(() => {
  window.translator.load("user").then(() => {
    let viewModel = new ViewModel(window.MODEL);
    ko.applyBindings(viewModel, document.querySelector(".login"));
  });
});
